<script>
export default {
  name: "swithLanguage",
  data() {
    return {
      options: [
        {
          value: 'zh-cn',
          label: '中文',
        },
        {
          value: 'zh-tw',
          label: '繁体中文',
        },
        {
          value: 'en',
          label: 'English',
        },
        {
          value: 'ko',
          label: '한국어',
        },
        {
          value: 'ar',
          label: 'اللغة العربية',
        },
        {
          value: "vi",
          label: "Tiếng Việt"
        }
      ],
      value: "zh-cn"
    }
  },
  methods: {
    changeLanguage(e) {
      this.$i18n.locale = e;
      window.localStorage.setItem("language", e)
    }
  },
  created() {
    let language = window.localStorage.getItem("language");
    if (language) {
      this.value = language
      this.$i18n.locale = language;
    }
  }
}
</script>

<template>
  <div class="lang-switcher">
    <span class="lang-icon">🌐</span>
    <el-select
      v-model="value"
      placeholder="Select"
      class="lang-select"
      popper-class="lang-dropdown"
      effect="dark"
      @change="changeLanguage"
    >
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
        :disabled="item.disabled" />
    </el-select>
  </div>
</template>

<style scoped>
.lang-switcher {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px 6px 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-sm);
  transition: border-color var(--transition), background var(--transition);
}

.lang-switcher:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.16);
}

.lang-icon {
  font-size: 15px;
  line-height: 1;
  opacity: 0.6;
}

.lang-select {
  width: 110px;
}

.lang-select :deep(.el-input__wrapper) {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.lang-select :deep(.el-input__inner) {
  color: var(--text-secondary) !important;
  font-weight: 500;
  font-size: 13px;
}

.lang-select :deep(.el-input__suffix) {
  color: var(--text-muted);
}
</style>
